export const hr= {
    'Print Label': 'Ispiši naljepnicu',
    'Printing label for {{article}}': 'Ispis naljepnice za {{article}}',
    'Today': 'Danas',
    'Yesterday': 'Jučer',
    'This Week': 'Ovaj tjedan',
    'Last 7 Days': 'Zadnjih 7 dana',
    'Last 30 Days': 'Zadnjih 30 dana',
    'This Month': 'Ovaj mjesec',
    'Homepage': 'Homepage',
    'Main Dashboard': 'Main Dashboard',
    'Inventory Dashboard': 'Inventory Dashboard',
    'Chat': 'Chat',
    'Shelf Planner': 'Shelf Planner',
    'Reports': 'Reports',
    'Catalog': 'Catalog',
    'Stored Items': 'Stored Items',
    'Replenishments': 'Replenishments',
    'Expired': 'Expired',
    'Transfers': 'Transfers',
    'In Progress': 'In Progress',
    'Cancelled': 'Cancelled',
    'Suspended': 'Suspended',
    'Customers': 'Customers',
    'Goods In': 'Goods In',
    'All': 'All',
    'PTL Rack': 'PTL Rack',
    'Cross-Docking': 'Cross-Docking',
    'Resources': 'Resources',
    'Shelf Maps': 'Shelf Maps',
    'Warehouses & Zones': 'Warehouses & Zones',
    'Import Data': 'Uvezi podatke',
    'Units of Measure': 'Units of Measure',
    'Smart Tags': 'Smart Tags',

    "Login": "Login",
    "Please enter your credentials to sign in!": "Please enter your credentials to sign in!",
    "Email": "Email",
    "Password": "Password",
    "Remember Me": " Remember Me",
    "Forgot Password?": "Forgot Password?",
    "Signing in...": "Signing in...",
    "Sign In": "Sign In",
    "Incorrect email or password": "Incorrect email or password",

    "Forgot Password": "Forgot Password",
    "Check your email": "Check your email",
    "We have sent a password recovery instruction to your email": "We have sent a password recovery instruction to your email",
    "Please enter your email address to receive a verification code": "Please enter your email address to receive a verification code",
    "Resend Email": "Resend Email",
    "Send Email": "Send Email",
    "Back to": "Back to",
    "Sign in": "Sign in",
    "Reset done": "Reset done",
    "Your password has been successfully reset": "Your password has been successfully reset",
    "Set new password": "Set new password",
    "Your new password must different to previous password": "Your new password must different to previous password",
    "Confirm Password": "Confirm Password",
    "Company Name": "Company Name",
    "Sign Up": "Sign Up",
    "Creating Account...": "Creating Account...",
    "Already have an account?": "Already have an account?",
    "Don't have an account?": "Don't have an account?",
    "Please enter your email": "Please enter your email",
    "Please enter your password": "Please enter your password",
    "Please confirm your password": "Please confirm your password",
    "Please enter your company name": "Please enter your company name",
    "Your passwords do not match": "Your passwords do not match",

    "Submitting ...": "Submitting ...",
    "Submit": "Submit",
    "Continue": "Continue",

    "Inventory": "Inventory",
    "Dashboard": "Dashboard",
    "Filter": "Filter",
    "Pick Confirmed": "Pick Confirmed",
    "Sold": "Sold",
    "Short Items": "Short Items",
    "Fix": "Fix",
    "Status": "Status",
    "Paid": "Paid",
    "Pending": "Pending",
    "Failed": "Failed",
    "Date": "Date",
    "Amount": "Amount",
    "Snapshot Variance Reports": "Snapshot Variance Reports",
    "Unique Items": "Unique Items",
    "Total Item Count": "Total Item Count",
    "Stock Count": "Stock Count",
    "Inbound Items": "Inbound Items",

    "Available": "Available",
    "Low Stock": "Low Stock",
    "Out of Stock": "Out of Stock",
    "Total Stock": "Total Stock",

    "Value Distribution": "Value Distribution",
    "Vertical": "Vertical",
    "Racking": "Racking",
    "Quarantine": "Quarantine",
    "Inspection": "Inspection",

    "Variance Value": "Variance Value",
    "Warehouse Capacity": "Warehouse Capacity",

    "Activities": "Activities",
    "View All": "View All",
    "No Activities": "No Activities",

    "Batch Cycles": "Batch Cycles",
    "Batch Runs": "Batch Runs",
    "Performance": "Performance",
    "Staff": "Staff",

    "Pending Jobs": "Pending Jobs",
    "Completed Jobs": "Completed Jobs",
    "Put away": "Put away",
    "Picks Completed": "Picks Completed",
    "Active Staff": "Active Staff",
    "Work Load": "Work Load",

    "Fulfilment Time (avg)": "Fulfilment Time (avg)",
    "Order": "Order",
    "Total": "Total",
    "Latest Orders": "Latest Orders",
    "View Orders": "View Orders",

    "Categories": "Categories",

    "Orders Dashboard": "Orders Dashboard",
    "View your current sales & summary": "View your current sales & summary",
    "Sales Report": "Sales Report",
    "Export Report": "Export Report",

    "Revenue": "Revenue",
    "Orders": "Orders",
    "Purchases": "Purchases",

    "Processing": "Processing",
    "Return": "Return",
    "Units": "Units",
    "Scan Confirmed": "Scan Confirmed",

    "Top Selling": "Top Selling",
    "View Products": "View Products",
    "Article": "Article",
    "Title": "Title",
    "Quantity": "Quantity",
    "Expired Date": "Expired Date",

    "Product": "Product",
    "Products": "Products",
    "Warehouse": "Warehouse",
    "Zone": "Zone",
    "Lift": "Lift",
    "Lifts": "Lifts",
    "Lift Type": "Lift Type",
    "Lift Types": "Lift Types",
    "Lift Number": "Lift Number",
    "Lift Name": "Lift Name",
    "Shelf": "Shelf",
    "Shelves": "Shelves",
    "User": "User",
    "Users": "Users",
    "User name": "User name",
    "Username": "Username",
    "Access point": "Access point",
    "Barcode": "Barcode",
    "Width": "Width",
    "Height": "Height",
    "Depth": "Depth",
    "Depths": "Depths",
    "Compartment": "Compartment",
    "Compartments": "Compartments",
    "Type": "Type",
    "S/C/D": "S/C/D",
    "Created": "Created",
    "Color": "Color",
    "Count":"Count",
    "Counts":"Counts",
    "Max": "Max",
    "Put": "Put",
    "Pick": "Pick",
    "Location": "Location",
    "Locations": "Locations",
    "Description": "Description",
    "Pick Sheet": "Pick Sheet",
    "Movements": "Movements",
    "Movement": "Movement",
    "Job Name": "Job Name",
    "Required Quantity": "Required Quantity",
    "Actual Quantity": "Actual Quantity",
    "Other": "Other",
    "Bin": "Bin",
    "Bins": "Bins",
    "Setting": "Setting",
    "Settings": "Settings",
    "Max Qty.": "Max Qty.",

    "Filter by dates range": "Filter by dates range",
    "Min Qty.": "Min Qty.",
    "Current Stock": "Current Stock",
    "Transfer": "Transfer",
    "Add Product": "Add Product",

    "No product found!": "No product found!",
    "Add": "Add",
    "Cancel": "Cancel",
    "Save": "Save",
    "Edit": "Edit",
    "Delete": "Delete",
    "Discard": "Discard",

    "Track #": "Track #",
    "Order Date": "Order Date",
    "Shipping Method": "Shipping Method",
    "Supplier": "Supplier",

    "Related Products": "Related Products",
    "Consignment": "Consignment",
    "Consigned": "Consigned",
    "Owner": "Owner",
    "Search Owner": "Search Owner",

    "Scan to pick": "Scan to pick",
    "Active": "Active",
    "Block": "Block",
    "Pick Method": "Pick Method",
    "FIFO": "FIFO",
    "Optimised": "Optimised",
    "Security": "Security",
    "Stock Take": "Stock Take",
    "Stock Valuation": "Stock Valuation",

    "Unit Of Measure": "Unit Of Measure",
    "Print Label on Pick": "Print Label on Pick",
    "Is Serialised": "Is Serialised",

    "Receiving": "Receiving",

    "This field is required": "This field is required",
    "Enter correct url!": "Enter correct url!",
    "Something wrong! Can not upload file": "Something wrong! Can not upload file",
    "Max quantity of the bins are required": "Max quantity of the bins are required",
    "Product successfully added": "Product successfully added",
    "article is existed.": "article is existed.",
    "Error !!!": "Error !!!",
    "Min Quantity": "Min Quantity",
    "UOM": "UOM",
    "Fifo": "Fifo",
    "Pick multiplier": "Pick multiplier",
    "Put away multiplier": "Put away multiplier",
    "Buy Price": "Buy Price",
    "Sell Price": "Sell Price",
    "ERP Code": "ERP Code",
    "Manufacturer": "Manufacturer",
    "Model": "Model",
    "Make": "Make",
    "Is serial numbered": "Is serial numbered",
    "H1": "H1",
    "H2": "H2",
    "H3": "H3",
    "H4": "H4",
    "H5": "H5",
    "H6": "H6",
    "Auto print label": "Auto print label",
    "Scan pick": "Scan pick",
    "Product Image": "Product Image",
    "Please upload a image file!": "Please upload a image file!",
    "Upload image cannot more then {{size}}kb !": "Upload image cannot more then {{size}}kb !",
    "Add or change image for the product": "Add or change image for the product",
    "Drop your image here, or": "Drop your image here, or",
    "browse": "browse",
    "Support: image files": "Support: image files",
    "Use Webcam": "Use Webcam",
    "Capture photo": "Capture photo",
    "Are you sure you want to delete this product? All record related to this product will be deleted as well. This action cannot be undone.": "Are you sure you want to delete this product? All record related to this product will be deleted as well. This action cannot be undone.",
    "Delete product": "Delete product",

    "Counted": "Counted",
    "Completed": "Completed",

    "Category": "Category",
    "Created At": "Created At",
    "Started At": "Started At",
    "Completed At": "Completed At",
    "Item count": "Item count",
    "Value": "Value",
    "Recounted": "Recounted",
    "Variance": "Variance",
    "Approved": "Approved",

    "Checked": "Checked",
    "Checked By": "Checked By",
    "Checked Date": "Checked Date",
    "Comment": "Comment",
    "Sending ...": "Sending ...",
    "Send": "Send",
    "Recount All": "Recount All",
    "Approval All": "Approval All",
    "Matching": "Matching",
    "Recount": "Recount",

    "Count Name": "Count Name",
    "Cycle Count": "Cycle Count",
    "Select the stock take group to count.": "Select the stock take group to count.",
    "In which warehouse": "In which warehouse",
    "Should the articles being counted now be made inactive so they they can not be picked or put until after they have been counted ?": "Should the articles being counted now be made inactive so they they can not be picked or put until after they have been counted ?",
    "Cycle A": "Cycle A",
    "Cycle B": "Cycle B",
    "Cycle C": "Cycle C",
    "No Count": "No Count",

    "All Locations": "All Locations",
    "Shelf Size": "Shelf Size",
    "Lift/Rack Name": "Lift/Rack Name",

    "Bulk": "Bulk",
    "Cross Docking": "Cross Docking",
    "Inspections": "Inspections",
    "Locker": "Locker",
    "Lockers": "Lockers",
    "Open Door": "Open Door",
    "Set Size Info": "Set Size Info",
    "Size": "Size",
    "Put Date": "Put Date",
    "Contact": "Contact",
    "Are you sure you want to delete this lift? All record related to this lift will be deleted as well. This action cannot be undone.": "Are you sure you want to delete this lift? All record related to this lift will be deleted as well. This action cannot be undone.",
    "Delete lift": "Delete lift",
    "Add Location": "Add Location",
    "Location successfully added": "Location successfully added",
    "The location is existed": "The location is existed",
    "Rack Number": "Rack Number",
    "Start Rack": "Početni regal",
    "End Rack": "Završni regal",
    "Creating racks": "Kreiranje regala",
    "Rack": "Regal",
    "Rack Name": "Rack Name",
    "Rack Description": "Rack Description",
    "Shelves (S)": "Shelves (S)",
    "Compartments (C)": "Compartments (C)",
    "Depths (D)": "Depths (D)",
    "Box Positions (D)": "Box Positions (D)",
    "Shelf Width (mm)": "Shelf Width (mm)",
    "Shelf Depth (mm)": "Shelf Depth (mm)",
    "No lift found!": "No lift found!",
    "No locker found!": "No locker found!",
    "Required": "Required",

    "Speed": "Speed",
    "Security Groups": "Security Groups",
    "Notes": "Notes",

    "Assign a Shelf map": "Assign a Shelf map",
    "I understand": "I understand",
    "Select the shelf map to assign.": "Select the shelf map to assign.",
    "Actions": "Actions",
    "Shelf Map": "Shelf Map",

    "Add Vertical": "Add Vertical",
    "Edit Vertical": "Edit Vertical",
    "Please Select": "Please Select",
    "Lift Group": "Lift Group",
    "Lock Timer (seconds)": "Lock Timer (seconds)",
    "Number Of Shelves": "Number Of Shelves",
    "Shelf Width": "Shelf Width",
    "Shelf Depth": "Shelf Depth",
    "Serial Number": "Serial Number",
    "License Key": "License Key",
    "Login Required": "Login Required",
    "Manage Articles": "Manage Articles",
    "Auto Generated Article Codes": "Auto Generated Article Codes",
    "Use Security": "Use Security",
    "Vertical successfully added. Restart the mpx VLM Services to activate the new lift": "Vertical successfully added. Restart the mpx VLM Services to activate the new lift",
    "Generic Error": "Generic Error",
    "Access Point": "Access Point",
    "Language": "Language",
    "Controller PC IP address": "Controller PC IP address",
    "Label Printer": "Label Printer",
    "Printer": "Printer",
    "Article Label Format": "Article Label Format",
    "Question 1": "Question 1",
    "Question 2": "Question 2",
    "Allow Picking": "Allow Picking",
    "Allow Putting": "Allow Putting",
    "Allow Searching": "Allow Searching",
    "Allow Get Shelf": "Allow Get Shelf",
    "Reverse Shelf Map": "Reverse Shelf Map",
    "Store After Pick": "Store After Pick",
    "Store After Job": "Store After Job",
    "Manage Lift": "Manage Lift",
    "Manage Racking": "Manage Racking",
    "Manage Lockers": "Manage Lockers",
    "Enable Camera": "Enable Camera",
    "Left Camera": "Left Camera",
    "Right Camera": "Right Camera",
    "Images storage": "Images storage",
    "Select images storage": "Select images storage",
    "Local Storage": "Local Storage",
    "AWS S3": "AWS S3",
    "Local Path": "Local Path",
    "AWS Bucket Name": "AWS Bucket Name",
    "AWS Dir Name": "AWS Dir Name",
    "AWS Region": "AWS Region",
    "AWS Access Key Id": "AWS Access Key Id",
    "AWS Secret Access Key": "AWS Secret Access Key",

    // TODO : orders, pages, resources, shared, components (table, pagination, ...)
    'Put Away': 'Put Away',
    'Put Away Value': 'Put Away Value',
    'Returns': 'Returns',
    'units': 'units',
    'days': 'days',
    'Oldest Pending Job': 'Oldest Pending Job',
    'Average Orders Per Months': 'Average Orders Per Months',
    'Average Pending Time': 'Average Pending Time',
    'Picks': 'Picks',
    'Latest Order': 'Latest Order',
    'Oldest Pending': 'Oldest Pending',
    'Created Date': 'Created Date',
    'Customer': 'Customer',
    'Bin Types': 'Bin Types',
    // update 15/4/2026
    'Short': 'Short',
    'Assigned to': 'Assigned to',
    'Unassigned': 'Unassigned',
    'By': 'By',
    'History': 'History',
    'Failed to update priority': 'Failed to update priority',
    'Error': 'Error',
    'Change State': 'Change State',
    'Warehouse is required': 'Warehouse is required',
    'Zone is required': 'Zone is required',
    'Print job sheet ...': 'Print job sheet ...',
    'Print Job Sheet': 'Print Job Sheet',
    'Print MatchUp Sheet': 'Print MatchUp Sheet',
    'Add to Next Batch': 'Add to Next Batch',
    'Run Batch': 'Run Batch',
    'Close': 'Close',
    'Run': 'Run',
    'Batch run successfully': 'Batch run successfully',
    'Unable to communicate with PTL Controller : Batch run cannot be started': 'Unable to communicate with PTL Controller : Batch run cannot be started',
    'Paused': 'Paused',
    'Running': 'Running',
    'The selected orders must have the same customer or shipping address.': 'The selected orders must have the same customer or shipping address.',
    'Job': 'Job',
    'at': 'at',

    'Create Report': 'Create Report',
    'Report Section': 'Report Section',
    'Select category': 'Select category',
    'Report title': 'Report title',
    'Report description': 'Report description',
    'Report file': 'Report file',
    'File name': 'File name',
    'Report section is required': 'Report section is required',
    'Report file is required': 'Report file is required',
    'Add report': 'Add report',
    'Report': 'Report',
    'Select a report': 'Select a report',

    'Pivot Grid': 'Pivot Grid',
    'Stock on hand': 'Stock on hand',
    'Loading...': 'Loading...',
    'Select a category': 'Select a category',
    'Select an item': 'Select an item',
    'Region': 'Region',
    'City': 'City',
    'Select': 'Select',
    'Priority': 'Priority',

    'Invalid email': 'Invalid email',
    'Email Required': 'Email Required',
    'User Name Required': 'User Name Required',
    'Phone number is not valid': 'Phone number is not valid',
    'Personal Info': 'Personal Info',
    'Social': 'Social',
    'Facebook link': 'Facebook link',
    'Twitter link': 'Twitter link',
    'Pinterest link': 'Pinterest link',
    'LinkedIn link': 'LinkedIn link',
    'URL': 'URL',
    'Phone Number': 'Phone Number',
    'Bags': 'Bags',
    'Cloths': 'Cloths',
    'Shoes': 'Shoes',
    'Watches': 'Watches',
    'In Stock': 'In Stock',
    'Limited': 'Limited',
    'Out Of Stock': 'Out Of Stock',
    'Delivery Reference': 'Delivery Reference',
    'Containers': 'Containers',
    'Reference': 'Reference',
    'Line': 'Line',
    'Edit Shelf': 'Edit Shelf',
    'Add Shelf': 'Add Shelf',
    'Add Compartment': 'Add Compartment',
    'Edit Compartment': 'Edit Compartment',
    'Assigning a new shelf map will delete all existing location data and create a new empty shelf.': 'Assigning a new shelf map will delete all existing location data and create a new empty shelf.',

    'Shipping': 'Shipping',
    'Dispatched': 'Dispatched',
    'Integration Fired': 'Integracija pokrenuta',
    'Pack & Dispatch': 'Pack & Dispatch',
    'Tracking': 'Tracking',
    'Sort Bench': 'Sort Bench',
    'To Do': 'To Do',
    'Master List': 'Master List',
    'Remaining Items': 'Remaining Items',
    'Aurora AI': 'Aurora AI',
    'Forecasts': 'Forecasts',
    'No/Slow Moving': 'No/Slow Moving',
    'Location Dashboard': 'Location Dashboard',
    'User Dashboard': 'User Dashboard',
    'ASRS': 'ASRS',
    'PTL Gateways & Devices': 'PTL Gateways & Devices',
    'Apply': 'Apply',

    'Add User': 'Add User',
    'Add Group': 'Add Group',
    'Add Bin': 'Add Bin',
    'In Transit': 'In Transit',
    'Delivered': 'Delivered',
    'Export file name': 'Export file name',
    'Tracking Number': 'Tracking Number',
    'Address': 'Address',
    'Last Updated': 'Last Updated',
    'Search': 'Search',
    'Export': 'Export',
    'Refresh': 'Refresh',
    'Success': 'Success',
    'Must be a number': 'Must be a number',
    'IP Address': 'IP Address',
    'IP Port': 'IP Port',
    'DPI': 'DPI',
    'Printers': 'Printers',
    'Add Printer': 'Add Printer',
    'Printer Name': 'Printer Name',
    'ZPL Printer': 'ZPL Printer',
    'Edit Printer': 'Edit Printer',
    'Create New Printer': 'Create New Printer',
    'Delete Printer': 'Delete Printer',
    'Printer saved successfully': 'Printer saved successfully',
    'Printer deleted successfully': 'Printer deleted successfully',
    'Are you sure you want to delete this printer? This action cannot be undone.': 'Are you sure you want to delete this printer? This action cannot be undone.',
    'Jobs in Progress': 'Jobs in Progress',
    'Print Job Sheets': 'Print Job Sheets',
    'Print Rack Pick Sheets': 'Print Rack Pick Sheets',
    'Print Automation Pick Sheets': 'Print Automation Pick Sheets',
    'Search by article': 'Search by article',
    'No results found': 'No results found',
    'Progress': 'Progress',
    'Batch Run': 'Batch Run',
    'Batch Size': 'Batch Size',
    'Pending Picks': 'Pending Picks',
    'Article To Sort': 'Article To Sort',
    'Sorted': 'Sorted',
    'More': 'More',
    'mins': 'mins',
    'nav.apps.resources.printers': 'Printers',
    'nav.apps.shipping': 'Shipping',
    'nav.apps.shipping.dispatched': 'Dispatched',
    'nav.apps.shipping.packDispatch': 'Pack & Dispatch',
    'nav.apps.shipping.tracking': 'Tracking',
    'nav.apps.sortBench': 'Sort Bench',
    'nav.apps.sortBench.dashboard': 'Dashboard',
    'nav.apps.sortBench.jobsInProgress': 'Jobs in Progress',
    'nav.apps.sortBench.todo': 'To Do',
    'nav.apps.sortBench.masterList': 'Master List',
    'nav.apps.sortBench.remainingItems': 'Remaining Items',
    'WorkLoad per Lift': 'WorkLoad per Lift',
    'No data available': 'No data available',
    'Puts': 'Puts',
    'Automation': 'Automatika',
    'Unknown Lift': 'Nepoznati lift',
    'Print Location Labels': 'Ispiši naljepnice lokacije',
    'Sorter': 'Sortirač',
    'items': 'stavke',
    'Complete Job': 'Završi zadatak',
    'All items are picked. Do you want to set this job status to Completed?': 'Sve stavke su prikupljene. Želite li postaviti status zadatka na „Završeno”?',
}
